import {store} from "@/app/store";
import {setUnityBar} from "@/app/(game)/unity-game/unityBarSlice";

/**
 * 设置 unityBar 的值
 * @param value - 新的 unityBar 值（0-100）
 */
export const updateUnityBar = (value: number) => {
    store.dispatch(setUnityBar(value));
};
